/* eslint-disable import/prefer-default-export */
import { get } from '@src/services/NetworkUtils'

export const DashboardService = {
  getOverview: async (params) => await get('/v1/dashboard/overview', params),
  getMetrics: async (params) => await get('/v1/dashboard/metrics', params),
  getChart: async (params) => await get('/v1/dashboard/chart', params),
  getEmployees: async (params) => await get('/v1/dashboard/employees', params),
}
